export default __webpack_public_path__ + "static/media/gallery-castle.2c6b84da.webp";